import { render, staticRenderFns } from "./PageList.vue?vue&type=template&id=016268e8&"
import script from "./PageList.vue?vue&type=script&lang=ts&"
export * from "./PageList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports